import { endpoints } from '../core/apiConfig';
import client from '../core/Interceptor';

export const getUserDetailsById = async (id?: string) => {
  const response = await client.get(`${endpoints.auth.getUserUrl}?${id ? `username=${id}` : ''}`);
  return response.data;
};
